import * as filters from '../helpers/filters';

const Filters = {
    install: (Vue) => {
        Vue.prototype.$f = filters;
    },
};

export default Filters;
